<div class="translation-container">
  <h1>{{ 'trad_title' | translate }}</h1>

  <div class="controls">
    <div class="lang-selection">
      <mat-checkbox *ngFor="let lang of langs" [checked]="isLangSelected(lang)" (change)="toggleLang(lang)">
        {{ lang.toUpperCase() }}
      </mat-checkbox>
    </div>

    <mat-form-field appearance="outline" class="search-field">
      <mat-label>{{ 'trad_search_placeholder' | translate }}</mat-label>
      <input matInput [(ngModel)]="searchText" />
    </mat-form-field>

    <div class="export-buttons">
      <button mat-raised-button color="primary" (click)="downloadCsv()">{{ 'trad_download_csv' | translate }}</button>
      <button mat-raised-button *ngFor="let lang of langs" (click)="downloadJson(lang)">
        {{ 'trad_download_json' | translate: { lang: lang.toUpperCase() } }}
      </button>
    </div>
  </div>

  <div class="keys-count">{{ 'trad_keys_count' | translate: { count: filteredKeys.length } }}</div>

  <div class="table-container">
    <table>
      <thead>
        <tr>
          <th class="col-key">{{ 'trad_col_key' | translate }}</th>
          <th *ngFor="let lang of selectedLangsArray" class="col-lang">{{ lang.toUpperCase() }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let key of filteredKeys">
          <td class="col-key">{{ key }}</td>
          <td *ngFor="let lang of selectedLangsArray" class="col-lang">{{ getValue(key, lang) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
